import CartItem from '../components/cart/CartItem';

const selectors = {
  cart: '[data-cart]',
  cartIcon: '[data-cart-icon]',
  cartItem: '[data-cart-item]',
};

export default class MainCart {
  constructor(section) {
    this.el = section.el;
    this._init();
  }

  _init = () => {
    this.cart = this.el.querySelector(selectors.cart);
    this.cartIcon = document.querySelector(selectors.cartIcon);

    this._attachListeners();
  };

  _attachListeners = () => {
    const cartItems = this.cart.querySelectorAll(selectors.cartItem);
    cartItems.forEach(item => {
      new CartItem(item, this.updateCart);
    });
  };

  updateCart = res => {
    const responseText = res.sections['main-cart'];
    const mainHtml = new DOMParser().parseFromString(responseText, 'text/html');
    this.cart.innerHTML = mainHtml.querySelector(selectors.cart).innerHTML;

    const cartTrigger = res.sections['main-cart-trigger'];
    const triggerHtml = new DOMParser().parseFromString(
      cartTrigger,
      'text/html',
    );
    this.cartIcon.innerHTML = triggerHtml.querySelector(
      selectors.cartIcon,
    ).innerHTML;

    this._attachListeners();
  };
}
